import { Link } from "react-router-dom"

const BlueFooter = (props) => {
    
    const { isMobile } = props

    return (
        <section className="blue-footer">
            <section className={isMobile ? "flex wrap gap-20 acenter jcenter footer-section-mobile" : "flex gap-20 acenter jcenter footer-section"}>

                <Link to="https://www.spica.es/" className="footer-link">© Spica S.L.</Link>
                <Link to="/legal/" className="footer-link">Aviso legal</Link>
                <Link to="/politica-de-privacidad/" className="footer-link">Política de privacidad</Link>
                <Link to="/certificaciones/" className="footer-link">Certificaciones</Link>

            </section>
        </section>
    )

}

export default BlueFooter